import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";
import { FAQS } from "../../lib/content";

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: FAQS.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
};

export const FaqSection = ({ items = FAQS, withSchema = true }) => (
  <section id="perguntas-frequentes" data-testid="faq-section" className="bg-white py-24 sm:py-32">
    {withSchema && <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />}
    <div className="container-x grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-4">
        <div className="lg:sticky lg:top-32">
          <Eyebrow>Perguntas frequentes</Eyebrow>
          <Reveal><h2 className="mt-5 font-display text-4xl font-semibold leading-[0.95] tracking-tight text-forest sm:text-5xl">Respostas claras, antes de decidir.</h2></Reveal>
          <p className="mt-6 text-ink/75 leading-relaxed">Custos e poupanças dependem sempre de fatores concretos. Estas respostas ajudam a perceber o que é avaliado.</p>
        </div>
      </div>
      <Accordion type="single" collapsible className="lg:col-span-8" data-testid="faq-accordion">
        {items.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="border-forest/15">
            <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg font-medium tracking-tight text-forest hover:no-underline hover:text-[#7a4f00] sm:text-xl">
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="pb-6 text-[15px] leading-relaxed text-ink/80 sm:text-base">{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
